import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import * as CryptoJS from "crypto-js";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly tagKey = "15l!VF!ve_P15rtr@!t19";

  constructor(
    private router: Router,
    private toastr: ToastrService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const originalKey = this.decryptAccessKey(sessionStorage.getItem("AccessKey"));

    if (originalKey) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${originalKey}`,
        },
      });
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        return this.handleError(error);
      })
    );
  }

  private decryptAccessKey(accessKey: string): string | null {
    if (!accessKey) return null;

    const passphrase = this.tagKey;
    const bytes = CryptoJS.AES.decrypt(accessKey, passphrase);
    return bytes.toString(CryptoJS.enc.Utf8);
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    const httpErrorCode = error.status;

    switch (httpErrorCode) {
      case 401:
        this.handleUnauthorizedError();
        break;
      default:
        // Handle other errors if needed
        break;
    }

    return throwError(error);
  }

  private handleUnauthorizedError(): void {
    if (sessionStorage.getItem("AccessKey")) {
      this.router.navigateByUrl("/WebPanel/proofcard-login");
      this.toastr.show(
        "You have been logged out from the system due to inactivity.",
        "Session Timeout!!",
        {
          positionClass: "toast-center-center",
        }
      );
      sessionStorage.clear();
      localStorage.clear();
    }
  }
}
